import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MenuPanel extends Component {
   handleClick() {
      document.getElementById('close-menu').click();
   }

   render() {
      return (
         <div className="flex menu" id="menu-panel">
            <div className="justify-center">
               <div className="container">
                  <div className="column">
                     <div className="justify-end">
                        <span className="close-menu" id="close-menu">
                           X
                        </span>
                     </div>
                     <div className="menu-list align-center">
                        <div className="column">
                           <Link
                              className="link"
                              to="/inicio"
                              onClick={this.handleClick.bind(this)}
                           >
                              INICIO
                           </Link>
                           <Link
                              className="link"
                              to="/catalogo"
                              onClick={this.handleClick.bind(this)}
                           >
                              CATÁLOGO
                           </Link>
                           <Link
                              className="link"
                              to="/carrito"
                              onClick={this.handleClick.bind(this)}
                           >
                              CARRITO
                           </Link>
                           <Link
                              className="link"
                              to="/nosotros"
                              onClick={this.handleClick.bind(this)}
                           >
                              NOSOTROS
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default MenuPanel;



// WEBPACK FOOTER //
// ./src/components/Header/menupanel.js